var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserGray = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsxs("svg", __assign({ width: '64', height: '64', viewBox: '0 0 64 64', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: [_jsx("circle", { opacity: '0.05', cx: '32', cy: '32', r: '32', fill: '#212A3D' }), _jsx("path", { d: 'M32 30C36.4183 30 40 26.4183 40 22C40 17.5817 36.4183 14 32 14C27.5817 14 24 17.5817 24 22C24 26.4183 27.5817 30 32 30Z', fill: '#A2A9BC' }), _jsx("path", { d: 'M19.1197 50H44.8803C47.7348 50 49.9336 47.5686 48.6007 45.0684C46.6396 41.3905 42.1692 37 32 37C21.8308 37 17.3603 41.3905 15.3993 45.0684C14.0663 47.5686 16.2651 50 19.1197 50Z', fill: '#A2A9BC' })] })));
};
export { UserGray };
//# sourceMappingURL=UserGray.js.map